import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import axios from "axios";
import DataSource from "devextreme/data/data_source";
import ArrayStore from "devextreme/data/array_store";
import {
    Column,
    DataGrid,
    FilterRow,
    Sorting,
    Paging,
    Pager,
    Export,
    ColumnChooser,
    ColumnChooserSearch,
} from "devextreme-react/data-grid";
import notify from 'devextreme/ui/notify';
import apiRoutes from "../../../../assets/apiRoutes.json";
import { MESSAGES } from "../../../../common/Messages";
import { EMPTY_GUID, GRID_PAGE_SIZES, CURRENCY_FORMAT } from '../constants';
import SelectCustomerPlaceholder from './SelectCustomerPlaceholder';

// Backed by OpenItemService.GetOpenItemTransactions, which returns OpenItemDTO rows: AR
// open-item transactions for the customer with the OM transaction headers unioned in.
// Legacy's "Transactions" tab was itself gated behind "OM module installed"; this covers the
// two modules that gate implied, not a full AR+OM+FM union (no FM freight bills).
function TransactionsTab(props) {
    const accessToken = props?.oidc?.user?.access_token;
    const hasCustomer = !!props.customerId && props.customerId !== EMPTY_GUID;
    const [resultData, setResultData] = useState(null);

    useEffect(() => {
        if (!hasCustomer) {
            setResultData(null);
            return;
        }
        const url = `${window._env_.REACT_APP_APIS}/${apiRoutes.AR.GetOpenItemTransactions}?customerId=${props.customerId}`;
        axios.get(url, {
            headers: { Authorization: `Bearer ${accessToken}`, access_token: accessToken }
        }).then((response) => {
            setResultData(new DataSource({ store: new ArrayStore({ key: 'RowId', data: response.data || [] }) }));
        }).catch((error) => {
            notify(error?.response?.data?.message || MESSAGES.FOLLOW_UP_TRANSACTIONS_LOAD_ERROR, 'error', 5000);
        });
    }, [accessToken, hasCustomer, props.customerId]);

    if (!hasCustomer) {
        return <SelectCustomerPlaceholder content="transactions" />;
    }

    return (
        <DataGrid
            dataSource={resultData}
            showBorders={true}
            allowColumnReordering={true}
            allowColumnResizing={true}
            hoverStateEnabled={true}
            searchEnabled={true}
            columnAutoWidth={true}
            className="popupGrid-height"
        >
            <ColumnChooser enabled={true} title="Choose Column" width={290} height={290} sortOrder="asc">
                <ColumnChooserSearch enabled={true} editorOptions={{ placeholder: 'Search column' }} />
            </ColumnChooser>
            <Export enabled={true} />
            <Sorting visible={true} mode="multiple" />
            <Paging defaultPageSize={10} />
            <Pager visible={true} showPageSizeSelector={true} allowedPageSizes={GRID_PAGE_SIZES} showNavigationButtons={true} />
            <FilterRow visible={true} />

            {/* Column set mirrors grdBottomAllTransactions. Type/Status show the ABFLAGFIELDS
                description, matching the legacy grid's TDBFlagCombo-bound columns rather than
                the raw one-character codes. Field names are OpenItemDTO's. */}
            <Column dataField="RecordNumber" caption="Record #" dataType="string" />
            <Column dataField="Module" caption="Module" dataType="string" />
            <Column dataField="TransactionTypeDescription" caption="Type" dataType="string" />
            <Column dataField="TransactionNumber" caption="Transaction #" dataType="string" />
            <Column dataField="TransactionDate" caption="Transaction Date" dataType="datetime" />
            <Column dataField="OriginalAmount" caption="Amount" dataType="number" format={CURRENCY_FORMAT} />
            <Column dataField="StatusDescription" caption="Status" dataType="string" />
            <Column dataField="ReferenceNumber" caption="Reference" dataType="string" />

            {/* Column chooser (hidden by default) */}
            <Column dataField="Description" caption="Description" dataType="string" visible={false} />
            <Column dataField="Comment" caption="Comment" dataType="string" visible={false} />

            <Column dataField="TransactionType" caption="Type Flag" dataType="string" visible={false} showInColumnChooser={false} />
            <Column dataField="StatusFlag" caption="Status Flag" dataType="string" visible={false} showInColumnChooser={false} />
            <Column dataField="RecordType" caption="Record Type" dataType="string" visible={false} showInColumnChooser={false} />
            <Column dataField="RCustomer" caption="Customer Id" visible={false} showInColumnChooser={false} />
            <Column dataField="RowId" caption="Row Id" visible={false} showInColumnChooser={false} />
        </DataGrid>
    );
}

function mapStateToProps(state) {
    return {
        oidc: state.oidc
    };
}

export default connect(mapStateToProps)(TransactionsTab);
